// Theme entry: site-wide UI behavior.
// Each module is opt-in: if its target HTML doesn't exist on the page, it no-ops.
// To remove a feature, just delete its import + call.
import { initCookiebox } from './modules/cookiebox';
import { initSmoothScroll } from './modules/smooth-scroll';
import { initPageUp } from './modules/pageup';
import { initImageSwitch } from './modules/image-switch';
import { initAccordion } from './modules/accordion';
import { initDrawer } from './modules/drawer';
import { initHeaderScroll } from './modules/header-scroll';
import { initCf7SubmitGuard } from './modules/cf7-submit-guard';
import { initScrollEffect, nudgeScrollOnLoad } from './modules/scroll-effect';
import { initSlider } from './modules/slider';
import { initTopSlider } from './modules/top-slider';
import { initPickupSlider } from './modules/pickup-slider';
import { initNav } from './modules/nav';
import { initArchiveLoadMore } from './modules/archive-load-more';

document.addEventListener('DOMContentLoaded', () => {
  initCookiebox();
  initSmoothScroll();
  // initPageUp();
  initImageSwitch();
  initAccordion();
  initDrawer();
  initHeaderScroll();
  initCf7SubmitGuard();
  initScrollEffect();
  initSlider();
  initTopSlider();
  initPickupSlider();
  initNav();
  initArchiveLoadMore();
});

nudgeScrollOnLoad();
